export default __webpack_public_path__ + "static/media/experience-banner.b9a33522.webp";